import React, {Component} from 'react'
import Navbar from 'components/dashboard/navbar'
import Banner from 'components/dashboard/bener'
import Kategori from 'components/dashboard/kategori'
import FalshSale from 'components/dashboard/flashSale'
import Toko from 'components/dashboard/toko'
import ProdukTerbaru from 'components/dashboard/produk_terbaru'
import Produk from 'components/dashboard/produk'
import Footer from 'components/dashboard/footer'
// import FlashSaleJson from 'json/dashboard/flash_sale'

export default class Dashboard extends Component {    
    render() {
        return (
            <>
                <Navbar />
                <Banner />
                <Kategori />
                <FalshSale />
                <Toko />
                <ProdukTerbaru />
                <Produk />
                <Footer />
            </>
        )
    }
    }
